/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { CHART_LEGEND_ALIGNMENT_TYPE_RIGHT } from '../../../../types/ChartLegendAlignment.types';
import { LineChartProps } from '../../LineChart.props';

/**
 * Parse LineChart props into a Highcharts format for the legend.
 */
export const getLineChartLegendOptions = (props: LineChartProps): Highcharts.Options => {
  const { alignLegend, hideLegend } = props;
  const options: Highcharts.Options = {
    legend: {
      enabled: !hideLegend,
      ...(alignLegend === CHART_LEGEND_ALIGNMENT_TYPE_RIGHT
        ? {
            align: 'right',
            layout: 'vertical',
            verticalAlign: 'top',
            y: 150,
          }
        : { align: 'center' }),
    },
  };
  return options;
};
